export default __webpack_public_path__ + "static/media/equilibrio-02.ecc624bd.jpg";